import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";

export const AddMapButton = ({ onClick }: { onClick: () => void }) => {
  const play = usePlaySound();

  const handleClick = () => {
    play();
    btnDelay(() => onClick());
  };

  return (
    <div className="absolute bottom-4 right-6 alpha pointer-events-auto">
      <button
        type="button"
        onClick={handleClick}
        aria-label={I18n.t("MSG_BUILDER_NEW_MAP_BTN")}
        className="type-inherit-font btn btn-primary flex-col-center !w-16 !h-16 !p-0 !m-0 !rounded-full"
      >
        <span className="material-symbols-outlined type-hero text-white">add</span>
      </button>
    </div>
  );
};
